module.exports = __webpack_public_path__ + "img/bggrey.775a2df6.png";